var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11282 7L13.7525 0.277539C13.847 0.16582 13.7675 -0.00390625 13.6214 -0.00390625H11.907C11.806 -0.00390625 11.7093 0.0412109 11.6427 0.118555L6.99133 5.66367L2.33997 0.118555C2.27551 0.0412109 2.17883 -0.00390625 2.07571 -0.00390625H0.361256C0.215162 -0.00390625 0.13567 0.16582 0.230201 0.277539L5.86985 7L0.230201 13.7225C0.209026 13.7474 0.19544 13.7778 0.191058 13.8102C0.186676 13.8426 0.191681 13.8756 0.20548 13.9052C0.219279 13.9348 0.241291 13.9599 0.268903 13.9774C0.296516 13.9949 0.328569 14.0041 0.361256 14.0039H2.07571C2.17669 14.0039 2.27337 13.9588 2.33997 13.8814L6.99133 8.33633L11.6427 13.8814C11.7072 13.9588 11.8038 14.0039 11.907 14.0039H13.6214C13.7675 14.0039 13.847 13.8342 13.7525 13.7225L8.11282 7Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCloseIcon);
export default __webpack_public_path__ + "static/media/gray-close-icon.321dabf86a50878cf39b4d1cd751240b.svg";
export { ForwardRef as ReactComponent };